export const selectProfile = (state) => state.userProfile.profile;
export const selectLoading = (state) => state.userProfile.loading;
export const selectUpdating = (state) => state.userProfile.updating;
export const selectError = (state) => state.userProfile.error;
export const selectUpdateError = (state) => state.userProfile.updateError;
